import { useState } from 'react';
import { site } from '../config';
import { topics } from '../data';
import { sendLead } from '../lib/lead';

export default function LeadForm({ source = 'contact-form', title = 'Request a Callback' }) {
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const values = Object.fromEntries(
      [...new FormData(form).entries()].map(([key, value]) => [key, String(value).trim()])
    );

    if (values._honey) return;
    if (!values.name || !values.phone) {
      setError('Please enter your name and phone number.');
      return;
    }

    setError('');
    setStatus('sending');
    try {
      await sendLead({ ...values, source });
      form.reset();
      setStatus('sent');
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
      setStatus('idle');
    }
  }

  if (status === 'sent') {
    return (
      <div className="form-card form-done">
        <h2>Thanks — we’ve got it</h2>
        <p>
          An agent will reach out shortly. Need help sooner? Call <a href={site.phoneHref}>{site.phone}</a>.
        </p>
        <button type="button" className="btn btn-primary" onClick={() => setStatus('idle')}>
          Send another request
        </button>
      </div>
    );
  }

  return (
    <form className="form-card" onSubmit={handleSubmit} noValidate>
      <h2>{title}</h2>
      <p className="form-sub">Tell us what’s happening and we’ll get back to you.</p>

      <input type="text" name="_honey" className="trap" tabIndex={-1} autoComplete="off" aria-hidden="true" />

      <div className="field-pair">
        <label>
          Name
          <input name="name" type="text" autoComplete="name" placeholder="Your name" required />
        </label>
        <label>
          Phone
          <input name="phone" type="tel" autoComplete="tel" placeholder="+1 555 000 0000" required />
        </label>
      </div>
      <label>
        Email
        <input name="email" type="email" autoComplete="email" placeholder="you@email.com" />
      </label>
      <label>
        Topic
        <select name="topic" defaultValue="">
          <option value="" disabled>
            Choose a topic
          </option>
          {topics.map((topic) => (
            <option key={topic.slug}>{topic.title}</option>
          ))}
          <option>Something else</option>
        </select>
      </label>
      <label>
        Message
        <textarea name="message" rows={3} placeholder="Briefly describe the issue" />
      </label>

      {error && (
        <p className="form-error" role="alert">
          {error}
        </p>
      )}

      <button type="submit" className="btn btn-primary btn-block" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending…' : 'Send Request'}
      </button>
      <p className="form-note">We only use your details to respond to this request.</p>
    </form>
  );
}
